import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'textPipe',
})
export class TextPipePipe implements PipeTransform {
  transform(value: any, pipeName: string): any {
    if (!value && !pipeName) {
      return value;
    } else if (pipeName === 'lowercase') {
      return value.toLowerCase();
    } else if (pipeName === 'uppercase') {
      return value.toUpperCase();
    } else if (pipeName === 'capitalizeEachWord') {
      return value.toLowerCase().replace(/\b\w/g, function (char) {
        return char.toUpperCase();
      });
    } else if (pipeName === 'capitalize') {
      value=value.toLowerCase();
      return  value.charAt(0).toUpperCase() + value.slice(1);
    }
  }
}
